export const headers = [
  { name: 'Grupo', field: 'grouped', sortable: true },
  { name: 'Função', field: 'function', sortable: true },
  { name: 'Nome', field: 'name', sortable: true },
  { name: 'Ações', field: 'actions', sortable: false }
]
